import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatPageComponent } from './chat-page.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [ChatPageComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([{ path: '', component: ChatPageComponent }]),
    SharedModule,
  ],
})
export class ChatPageModule {}
